module.exports = __webpack_public_path__ + "img/homedog-left.cbb61395.png";